import { render, staticRenderFns } from "@/modules/Policy/templates/policies-list.html?vue&type=template&id=1edeb6f2&scoped=true&"
import script from "@/modules/Policy/scripts/policies-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Policy/scripts/policies-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Policy/styles/policies-list.scss?vue&type=style&index=0&id=1edeb6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edeb6f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
